"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Uploading = exports.Loading = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _lottieReact = _interopRequireDefault(require("lottie-react"));
var _loading = _interopRequireDefault(require("../lottie/loading.json"));
var _Style = require("../style/Style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Loading = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...stylex.props(_Style.loadingStyle.wrapper, props.isAppear ? _Style.loadingStyle.appear : _Style.loadingStyle.disappear),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ...stylex.props(_Style.loadingStyle.icon),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lottieReact.default, {
        animationData: _loading.default,
        loop: true
      }), ";"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ...stylex.props(_Style.textStyle.p1b, _Style.loadingStyle.message),
      children: props.message
    })]
  });
};
exports.Loading = Loading;
const Uploading = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...stylex.props(_Style.uploadingStyle.wrapper, props.isAppear ? _Style.uploadingStyle.appear : _Style.uploadingStyle.disappear),
    children: Object.keys(props.uploadings).map(name => {
      const uploading = props.uploadings[name];
      const progress = Math.round(uploading.current / uploading.total * 100);
      const text = progress === 100 ? 'のアップロードが完了しました' : 'をアップロード中...';
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [name, text, progress, "%"]
      });
    })
  });
};
exports.Uploading = Uploading;